module.exports = __webpack_public_path__ + "img/logout.ce84ced0.svg";